
function About() {
  return (
    <div>
      <h1>About Us</h1>
      <p>
        Welcome to our website! We are a team of passionate developers dedicated to creating the best
        user experiences through our applications.
      </p>
      <p>
        Our mission is to simplify technology for everyone and make the digital world more accessible
        to people around the globe.
      </p>
      <h1>Contact Information</h1>
        <p>
           <b>Phone</b>
        <br />
          <b>FMCSA Gateway Help Desk:</b> 855.537.7517
        </p>
        <p>
          <b>FMCSA Drug and Alcohol Clearinghouse Help Desk:</b> 844.955.0207
        </p>
        <p>
          <b>FMCSA Login.gov Help Desk:</b> 844.875.6446
      </p> 
      <p>
        <b>email</b>
        {/*
        <b>FMCSA Drug and Alcohol Clearinghouse Help Desk:</b> <a href="https://clearinghouse.fmcsa.dot.gov/contact">Clearing House Contact Page</a>
        */}
        <br />
        <p>
          <b>FMCSA Gateway Help Desk:</b>fmcsagatewaysupport@dot.gov
        </p>
        <b>FMCSA Drug and Alcohol Clearinghouse Help Desk:</b>clearinghouse@dot.gov
      </p>
        <p>
          <b>FMCSA Login.gov Help Desk:</b> <a href="https://login.gov/contact/">Login.gov Contact Page</a>
        </p>
    </div>
  );
}

export default About;
